module.exports = __webpack_public_path__ + "media/AddCandidate.afaee247.mp4";